import React, { useCallback } from 'react';
import { AnyObject } from 'final-form';

import { createFormField } from 'Shared/utils/createFormField';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

function PersonalMessage({ value, onChange }: AnyObject) {
  const handleChange = useCallback(event => onChange(event.target.value), [onChange]);
  const { tr } = useTranslation();

  return (
    <div>
      <div className="mt-4">{tr('perform.sync_meetings.personal_message.label')}</div>
      <textarea className="w-100 border rounded p-2 mt-1" value={value} onChange={handleChange} />
    </div>
  );
}

export default createFormField(PersonalMessage);
